import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: 'Home', href: '/', icon: 'home' },
    { label: 'About', href: '/about', icon: 'info' },
    { label: 'Football Agency', href: '/football-agency', icon: 'sports_soccer' },
    { label: 'Project Consultancy', href: '/project-consultancy', icon: 'project_consultancy' },
    { label: 'Our Team', href: '/members', icon: 'people' },
    { label: 'Insights', href: '/insights', icon: 'insights' },
    { label: 'Contact', href: '/contact', icon: 'mail' }
  ];

  return (
    <nav className="navbar-container">
      <div className="navbar-content">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <img 
            src="/logo.jpg" 
            alt="MAGBITY Agency Logo" 
            className="logo-image"
          />
        </Link>

        {/* Desktop Menu Items */}
        <div className="nav-menu desktop">
          {navItems.map((item, index) => (
            <Link 
              key={index} 
              to={item.href} 
              className={`nav-item ${location.pathname === item.href ? 'active' : ''}`}
            >
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </div>

        {/* Mobile Hamburger Button */}
        <button 
          className={`hamburger-menu ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile Dropdown Menu - always rendered so CSS can animate it */}
        <div className={`mobile-dropdown-menu ${mobileMenuOpen ? 'open' : 'closed'}`}>
          {navItems.map((item, index) => (
            <Link 
              key={index} 
              to={item.href} 
              className={`mobile-menu-item ${location.pathname === item.href ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
